<template>
  <div class="card-content">
    <div class="columns is-multiline">
      <div class="column is-3">
        <div class="is-italic">{{ $t('detailCommandeTlpe.infoGenerales.annee') }}</div>
        <p class="has-text-weight-bold">{{ commandeTlpe.anneeDeclaration }}</p>
      </div>
      <div class="column is-3">
        <div class="is-italic">{{ $t('detailCommandeTlpe.infoGenerales.typeDeclaration') }}</div>
        <p class="has-text-weight-bold">{{ $t(getLibelleTypeDeclaration) }}</p>
      </div>
      <div class="column is-3">
        <div class="is-italic">{{ $t('detailCommandeTlpe.infoGenerales.declarant') }}</div>
        <p class="has-text-weight-bold">{{ getNomPrenomCommercial }}</p>
      </div>
      <div class="column is-3">
        <div class="is-italic">{{ $t('detailCommandeTlpe.infoGenerales.referenceClient') }}</div>
        <p class="has-text-weight-bold">{{ commandeTlpe.referenceClient }}</p>
      </div>
      <div class="column is-3">
        <div class="is-italic">{{ $t('detailCommandeTlpe.infoGenerales.codeDossier') }}</div>
        <p class="has-text-weight-bold">{{ commandeTlpe.codeDossier }}</p>
      </div>
    </div>
  </div>
</template>

<script>

import { LISTE_TYPE_DECLARATION } from '@/configuration/gabed/tlpe/tlpeConf';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';

export default {
  props: {
    commandeTlpe: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getLibelleTypeDeclaration() {
      const typeDeclarationFind = LISTE_TYPE_DECLARATION.find((t) => {
        return t.code === this.commandeTlpe.typeDeclaration;
      });
      return typeDeclarationFind ? typeDeclarationFind.libelle : '';
    },
    getNomPrenomCommercial() {
      if (!this.commandeTlpe.commercial) return '';
      return nomPrenomGetter(this.commandeTlpe.commercial);
    },
  },
};

</script>
